@if ($model() != null && $currentUser() != null) {
    <div class="wrapper px-1">
        @if ($isFinished()) {
            <!-- Task info: Finished -->
            @if ($model().stateId == FlowObjectInstanceState.Finished) {
                <div class="message-container">
                    <div class="message-row">
                        <i class="fas fa-check-circle success mr-3"></i>
                        <span class="headline">
                            Comunicação com o sistema
                            <span class="text-highlight info-font">{{$configSchema().taskOutboundApi.publicSystemName}}</span>
                            realizada com sucesso
                        </span>
                        <i class="fas fa-check-circle success ml-3"></i>
                    </div>

                    @if (Utils.isNotNullOrEmpty($message())) {
                        @if ($isMessageFromApi()) {
                            <div class="message-row mt-4">
                                <p>Mensagem retornada pelo sistema:</p>
                            </div>
                        }

                        <div class="message-row" [class.mt-4]="!$isMessageFromApi()">
                            <span class="document-highlight info-font">{{$message()}}</span>
                        </div>
                    }

                    <hr />

                    <div class="message-row">
                        <span>Fluxo <b>encerrado</b></span>
                    </div>

                    @if (Utils.isNotNullOrEmpty($publicMessageHtml())) {
                        <hr />
                        <div class="public-message py-1"
                             [class.loading]="$isPublicMessageHtmlLoading()"
                             [safeHtmlContent]="$publicMessageHtml()"
                        >{{Enums.Messages.DefaultLoadingText}}</div>
                    }
                </div>
            }

            <!-- Task info: ManuallyFinished -->
            @if ($model().stateId == FlowObjectInstanceState.ManuallyFinished) {
                <div class="message-container">
                    <div class="message-row">
                        <i class="fas fa-check-circle success mr-3"></i>
                        <span class="headline">
                            Tarefa encerrada manualmente com sucesso pelos administradores do Fluxo
                        </span>
                        <i class="fas fa-check-circle success ml-3"></i>
                    </div>

                    <hr />

                    <div class="message-row">
                        <span>Fluxo <b>encerrado</b></span>
                    </div>

                    @if (Utils.isNotNullOrEmpty($publicMessageHtml())) {
                        <hr />
                        <div class="public-message py-1"
                             [class.loading]="$isPublicMessageHtmlLoading()"
                             [safeHtmlContent]="$publicMessageHtml()"
                        >{{Enums.Messages.DefaultLoadingText}}</div>
                    }
                </div>
            }

            <!-- Task info: ManuallyCancelled -->
            @if ($model().stateId == FlowObjectInstanceState.ManuallyCancelled) {
                <div class="message-container">
                    <div class="message-row">
                        <i class="fas fa-minus-circle error mr-3"></i>
                        <span class="headline">
                            Tarefa cancelada manualmente pelos administradores do Fluxo em
                            <span class="text-highlight info-font d-inline-block">{{getDateString()}}</span>
                        </span>
                        <i class="fas fa-minus-circle error ml-3"></i>
                    </div>

                    <hr />

                    <div class="message-row column">
                        <p>
                            Houve um erro na comunicação com o sistema
                            <span class="text-highlight info-font d-inline-block">{{$configSchema().taskOutboundApi.publicSystemName}}</span>
                            e os administradores do Fluxo
                            <span class="text-highlight info-font d-inline-block">{{$flowInstance().name}}</span>
                            optaram por cancelar manualmente esta instância de identificador
                            <span class="uppercase text-highlight info-font d-inline-block">{{$flowInstance().id}}</span>.
                        </p>
                        <p>
                            Para todos os efeitos, o Fluxo <b>não foi completado</b> e as eventuais Tarefas previamente executadas <b>não possuem validade</b>.
                        </p>
                        <span>
                            Inicie uma <b>nova instância</b> deste Fluxo para completar a requisição do serviço.
                        </span>
                    </div>
                </div>
            }
        } @else {
            <!-- Task info: Iniciada -->
            @if (!$isPollingFinished()) {
                <!-- Task info: polling em curso -->
                <div class="message-container py-2">
                    <div class="message-row mt-2">
                        <i class="fas fa-sync fa-spin await mr-3"></i>
                        <span class="headline">
                            Aguardando comunicação com o sistema
                            <span class="text-highlight info-font d-inline-block">{{$configSchema().taskOutboundApi.publicSystemName}}</span>
                        </span>
                        <i class="fas fa-sync fa-spin await ml-3"></i>
                    </div>

                    <div class="message-row mt-4">
                        <div class="bar-container" [class.second]="$hasEnqueuedAtFirst()">
                            <div class="progress-bar" [style.width.%]="$pollingProgress()">
                                @if ($hasEnqueuedAtFirst()) {
                                    <span class="text">Aguarde...</span>
                                } @else {
                                    <span class="text">Carregando...</span>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            } @else {
                <!-- Task info: ação pendente -->
                <div class="message-container">
                    <div class="message-row mt-2">
                        <i class="fas fa-minus-circle error mr-3"></i>
                        <span class="headline">
                            Erro na comunicação com o sistema
                            <span class="text-highlight info-font d-inline-block">{{$configSchema().taskOutboundApi.publicSystemName}}</span>
                        </span>
                        <i class="fas fa-minus-circle error ml-3"></i>
                    </div>

                    @if (Utils.isNotNullOrEmpty($message())) {
                        @if ($isMessageFromApi()) {
                            <div class="message-row">
                                <p>Mensagem retornada pelo sistema:</p>
                            </div>
                        }

                        <div class="message-row" [class.mt-4]="!$isMessageFromApi()">
                            <span class="document-highlight info-font">{{$message()}}</span>
                        </div>
                    }

                    <hr />

                    <!-- Task footer -->
                    <div class="message-row column mt-3">
                        <p>
                            A comunicação automatizada com o sistema
                            <span class="text-highlight info-font">{{$configSchema().taskOutboundApi.publicSystemName}}</span>
                            não pôde ser realizada.
                        </p>

                        @if (!$isResolver()) {
                            <!-- Task footer: visão do requerente -->
                            <div>
                                Em breve a equipe responsável atuará manualmente nesta Tarefa para que o Fluxo possa ser devidamente encerrado.
                            </div>
                        } @else {
                            <!-- Task footer: visão do executor -->
                            <p>Como membro do grupo resolvedor configurado para esta Tarefa, você está habilitado para executar uma das seguintes ações:</p>

                            <div class="message-row column button-row-container py-1">
                                <div class="button-row primary">
                                    <div class="keep top">
                                        <button type="button" class="btn btn-outline-primary"
                                                (click)="enqueueTask()"
                                        >Reexecutar</button>
                                    </div>
                                    <div class="keep bottom">
                                        <span>
                                            Enfileira a Tarefa novamente para execução. O Fluxo permanecerá no estado
                                            <b>Em andamento</b> aguardando o desfecho da Tarefa.
                                        </span>
                                    </div>
                                </div>

                                <div class="button-row success">
                                    <div class="keep top">
                                        <button type="button" class="btn btn-outline-success"
                                                (click)="updateTask(FlowObjectInstanceState.ManuallyFinished)"
                                        >Encerrar</button>
                                    </div>
                                    <div class="keep bottom">
                                        <span>
                                            Encerra com sucesso tanto a Tarefa quanto o Fluxo. Não haverá
                                            novas tentativas de comunicação com a API do sistema
                                            <span class="text-highlight info-font d-inline-block">{{$configSchema().taskOutboundApi.publicSystemName}}</span>.
                                        </span>
                                    </div>
                                </div>

                                <div class="button-row danger">
                                    <div class="keep top">
                                        <button type="button" class="btn btn-outline-danger"
                                                (click)="updateTask(FlowObjectInstanceState.ManuallyCancelled)"
                                        >Cancelar</button>
                                    </div>
                                    <div class="keep bottom">
                                        <span>
                                            Cancela tanto a Tarefa quanto o Fluxo, que por sua vez terá a
                                            validade <b>desconsiderada</b> para fins de auditoria — ainda que eventuais
                                            documentos tenham sido gerados e processados no E-Docs.
                                        </span>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        }
    </div>
} @else {
    <div class="wrapper loading">
        <span class="info-font text-highlight p-2">(Carregando...)</span>
    </div>
}
